module.exports = __webpack_public_path__ + "img/NKCLM-logo.d64dec5b.svg";